<div class="px-4 sm:px-8 lg:px-[74px] py-6 sm:py-10">

  <h2 class="text-2xl sm:text-3xl text-gray-900 text-center font-bold mb-6">Image Caption Generator</h2>


  <div class="flex mb-6">
    <div class="w-[800px] max-w-full mx-auto">
      <form #captionGeneratorForm="ngForm">
        <div class="upload-box" (click)="fileUploadRef.click()" (drop)="onDrop($event)" (dragover)="allowDrop($event)" (dragenter)="allowDrop($event)">
          <span>
            <img src="../../../../../../../assets/theme/images/icons/photo-plus.svg"  alt="photo-plus"
            class="w-6 h-6 cursor-pointer" />
          </span>
          <p>Click to Add or Drag & Drop Images</p>
          <input type="file" id="fileUpload" (change)="onSelect($event)" [accept]="allowedExtensions.join(',')"
            required ngModel class="hidden" #fileInput="ngModel"
            name="fileUpload" id="fileUpload" #fileUploadRef />
          <!-- <label for="fileUpload">Choose File</label> -->
        </div>
        @if (imageCaptionGeneratorRequestModel.image) {
        <div class="file-info cursor-pointer" (click)="clear()">
          <span class="file-name">{{ imageCaptionGeneratorRequestModel.image.name }}</span>
          <span class="clear-button">✖</span>
        </div>
        }
        @if(fileError){
        <div class="text-red-500 text-sm mt-2">{{this.fileError}}</div>
        }
      </form>
    </div>
  </div>

  <div class="mx-auto">



    <div class="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-4 w-full lg:w-[800px] max-w-full mx-auto">

      <div class="w-full min-h-[420px] shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white bg-nav-tabs">
        <div class="flex justify-end mb-1 ">
          @if(isLoading){
            <span
              class="border-black h-4 w-4 animate-spin rounded-full border-2 border-t-white ms-2"></span>
            }
            <!-- captionGeneratorForm.valid && isValidFile && imageCaptionGeneratorResponseModel.caption -->
          @if(imageCaptionGeneratorResponseModel.caption){
            <img  src="../../../../../../../assets/theme/images/icons/refresh.svg" title="Regenerate"  alt="regenerate"  (click)="regenerateImageCaption()"
            class="w-6 h-6 cursor-pointer" />
            <img [src]="getIcon"  alt="copy" title="Copy to Clipboard"  (click)="copyCaption()"
              class="w-6 h-6 cursor-pointer" />
          }

        </div>
        <textarea rows="10" type="text" placeholder="Your caption will appear here..." minlength="1" maxlength="500"
          name="Caption" #Caption="ngModel" id="Caption" [(ngModel)]="imageCaptionGeneratorResponseModel.caption"
          class="border border-gray-300 rounded-md px-3 py-2 w-full h-auto"></textarea>
      </div>


    </div>

  </div>


</div>
